import React from 'react';
import _ from 'lodash';
import Utils from './../../Utils/Utility';
import ReactTooltip from 'react-tooltip';

const CURBSIDEPICKUP = "Curbside PickUp";

export default class OrderDetail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            order         : [],
            chargeData: {},
            showCustomComponent: false
            // show:false
        };

        // this.showCustomChargeModal =   this.showCustomChargeModal.bind(this);
        this.getPlatformFee        =   this.getPlatformFee.bind(this);

    }

    componentWillMount() {

        this.setState({
            order: this.props.order,
            activeLocation: this.props.activeLocation
        });
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps != null){
            this.setState({
                order: nextProps.order
            });
        }
    }

    showCustomChargeModal(i){
        this.setState(prevState => ({
            showCustomComponent: !prevState.showCustomComponent
        }))
    }

    generateChosenOptionsList(chosenOptions, options) {
        const res = chosenOptions.map((cOption) => {
            const key = cOption.optionCategoryName;
            const idx = _.findIndex(options, (option) => option.category === key);

            const coKeyVal = cOption.selectedKeys.reduce((acc, key) => {
                acc[key] = ( acc[key] || 0 ) + 1;
                return acc;
            }, {});

            return Object.keys(coKeyVal).map((key, i) => {
                let price = "";
                let optionPrefix = "";
                if (options[idx][key] !== 0) {
                    price = `$${options[idx][key]}`;
                }

                if (coKeyVal[key] > 1) {
                    optionPrefix = ` - ${coKeyVal[key]} x `;
                }

                return (
                    <li key = {`${key}-${i}-${idx}`} className = "small">{key}{optionPrefix}{price}</li>
                );
            });
        });
        return <ul className = "list-unstyled">{res}</ul>;
    }

    generateChosenOptionsListNew(chosenOptions) {
        const res = chosenOptions.map((cOption) => {
            const coKeyVal = cOption.selectedKeys.reduce((acc, key) => {
                acc[key] = ( acc[key] || 0 ) + 1;
                return acc;
            }, {});

            return Object.keys(coKeyVal).map((key, i) => {
                let optionPrefix = "";

                if (coKeyVal[key] > 1) {
                    optionPrefix = `${coKeyVal[key]} x `;
                }

                let newOptionsVal = key;
                let addVal = " $";
                let indexPosition =  key.indexOf("-") + 1;

                if(indexPosition !== 0){
                    newOptionsVal = key.slice(0, indexPosition) + addVal + key.slice(indexPosition + 1);
                }

                return (
                    <li key = {`${key}-${i}-${coKeyVal[key]}`} className = "small">{optionPrefix}{newOptionsVal}</li>
                );
            });
        });

        return <ul className = "list-unstyled">{res}</ul>;
    }

    getCouponStructure(order) {
        const couponInfo = order.couponInfo;
        if (couponInfo && !Utils.isEmptyObj(couponInfo)) {
            let component = (
                <div>
                    <p className="disc-highlight">Applied coupon <b>{couponInfo.couponCode}</b> for this order.</p>
                    <br/>
                    <p>sub total <b className = "pull-right"> ${Utils.toRoundStr(order.subTotal, 2)}</b></p>
                    <p className="disc-highlight">Discount <b className="pull-right"> -${Number(couponInfo.discountAmount).toFixed(2)}</b></p>
                    <p>Discounted sub total <b className="pull-right"> ${Number(order.subTotal -  couponInfo.discountAmount).toFixed(2)}</b></p>
                </div>
            );
            return component;
        } else {
            return (
                <p>sub total <b className = "pull-right"> ${Utils.toRoundStr(order.subTotal, 2)}</b></p>
            );
        }
    }

    getDeliveryFeeStructure(order) {
        let component = null;

        if (order.deliveryFee) {
            component = ( <p>delivery fee<b className = "pull-right">${Utils.toRoundStr(order.deliveryFee, 2)}</b></p> );
        }

        return component;
    }

    getDriverTipStructure(order) {
        let component = null;
        if (order.tipAmount) {
            component = (
                <p>tip<b className="pull-right">${_.round((order.tipAmount || 0), 2).toFixed(2)}</b></p>
            );
        }
        return component;
    }

    //service fee comp
    getServiceFeeStructure(order) {
        let component = null;
        if (order.serviceFee) {
            // Code inside this block will only execute if order object contains service Fee
            component = (
                <p>service fee<b className="pull-right">${_.round((order.serviceFee || 0), 2).toFixed(2)}</b></p>
            );
        }
        return component;
    }

    getPlatformFee(order){

        let platformCharge = order.platformCharge;
        let customCharge = order.charge;
        let comp = null;

        if (!Utils.isEmpty(platformCharge)) {

            comp = (
                <div className="row">
                    <div className="container" style={{maxWidth: '100%'}}>
                        <div className='cart_border box-sizing '>
                            <div className={ customCharge !== undefined && customCharge.length > 0 ? "col-xs-12 mt-5 mb-2" : "col-xs-12 mt-5 mb-5"}>
                                <span className="item-in-cart"><b>Platform Charge: </b></span>
                                <span
                                    className="ft-16 platformfee-text"> ${Utils.toRoundStr(platformCharge, 2)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return comp;
    }

    getCustomChargeStructure(order){

        let customCharges = order.charge;
        if (customCharges !== undefined && customCharges.length > 0) {

            return customCharges.map((charge, index) => {

                let descComponent = null;
                if (!Utils.isEmpty(charge.desc)) {
                    descComponent = (
                        <span><a data-tip={charge.desc} className={'color-styl tooltip-button'}
                                 style={{ cursor : 'pointer' }}><i
                            className="fa fa-info-circle"
                        ></i>
                            </a>
                             <ReactTooltip place="right" wrapper="span"/>
                            </span>
                    );
                }

                return (
                    <p key={index}>{charge.name} {descComponent}<b
                        className="pull-right">${Utils.toRoundStr(charge.fee, 2)}</b></p>
                );

            });
        }
    }

    getCustomChargeStructureOfOptional(order){
        let customCharges = order.charge;
        let component = null;

        if(  customCharges !== undefined && customCharges.length > 0) {
            component = (
                <div className="row">
                    <div className="container" style={{maxWidth: '100%'}}>
                        <div className='cart-border'>
                            <div className={"col-xs-12 no-gutter"}>
                                <div className="mt-5 mb-5">
                                    {/*<h4 className="order-type-details"><b>{charge.name}: </b>{charge.optionName}</h4>*/}
                                    <span className="ft-16  ml-15"><b className="item-in-cart">Custom Charges: </b>
                                                <span className="text-dark ft-16">
                                            {order.charge.name}
                                                    <a href="javascript:void(0)" className="ft-16"
                                                       onClick={() => this.showCustomChargeModal()}>View Details
                                                        {!(this.state.showCustomComponent) ?
                                                            (
                                                                <i className="ml-5 fa fa-chevron-right"
                                                                   aria-hidden="true"></i>
                                                            )
                                                            : <i className="ml-5 fa fa-chevron-down"
                                                                 aria-hidden="true"></i>

                                                        }
                                        </a>
                                        </span>

                                            </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )


        }

        return component;

    }



    renderCustomChargeRow(order){

        let customCharges = order.charge;
        let component = null;

        if( customCharges !== undefined && customCharges.length > 0) {
            customCharges.map((charge, index) => {

                component = (
                    <div  key={index}>
                        {this.state.showCustomComponent ? (
                            <div className="row" >
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className=''>
                                        <div className={"col-xs-12 no-gutter"}>
                                            <div className={"order-type-div"}>
                                                <div className="col-xs-12 mt-10 no-gutter">
                                                    <div className="col-xs-6 no-gutter">
                                                        <h4 className="order-type-details ml-7">
                                                            <b>Charge: </b>
                                                            <span
                                                                className={"ft-16"}>{charge.name}  </span>
                                                        </h4>
                                                    </div>

                                                    <div className="col-xs-6 ">
                                                        <h4 className="order-type-details">
                                                            <b>Tag: </b>
                                                            <span
                                                                className={"ft-16"}> {charge.tag}</span>
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col-xs-12 no-gutter">
                                                    <div className="col-xs-6  no-gutter">
                                                        <h4 className="order-type-details ml-7">
                                                            <b>Description: </b>
                                                            <span
                                                                className={"ft-16"}>{charge.desc} </span>
                                                        </h4>
                                                    </div>

                                                    <div className="col-xs-6">
                                                        <h4 className="order-type-details">
                                                            <b>Type: </b>
                                                            <span
                                                                className={"ft-16"}> Optional </span>
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col-xs-12 mb-10 no-gutter">
                                                    <div className="col-xs-6 no-gutter">
                                                        <h4 className="order-type-details ml-7">
                                                            <b>Amount: </b>
                                                            <span
                                                                className={"ft-16"}>${charge.fee}</span>
                                                        </h4>
                                                    </div>

                                                    <div className="col-xs-6 ">
                                                        <h4 className="order-type-details">
                                                            <b>Tax: </b>
                                                            <span
                                                                className={"ft-16"}>${charge.tax}</span>
                                                        </h4>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>

                );
                // }
            });
        }

        return component;
    }

    getItemInstructions(itemOrderInst) {
        if (Utils.isEmpty(itemOrderInst)) {
            return null;
        }

        return (
            <ul className = "list-unstyled">
                <li><b>Instructions: </b>{`${itemOrderInst}`}</li>
            </ul>
        );
    }

    renderOrderRow() {
        const self = this;
        return this.state.order.items.map((item, index) => {

            return (
                <div  className="menu-container col-xs-12 no-gutter" key = {item.itemObjectId + index}>
                    <div className={"col-xs-8 items-price-container"}>
                        <div className={"order-type-details"}>
                            <h4 className = "item-in-cart">{item.itemName}</h4>
                            <h5> Qty: {item.itemQty} x ${item.itemPrice}</h5>
                            {self.generateChosenOptionsListNew(item.itemOptionCategories)}
                            {/*{self.getItemInstructions(item.itemOrderInst)}*/}
                        </div>
                    </div>

                    <div className={"col-xs-4 items-price-container"} style={{paddingLeft: "8px"}}>
                        <div className={"order-type-details order-item-price pull-right"}>
                            {/* <b>Order Type:</b> {Utils.getOrderTypeStr(order)} */}
                            <b>${item.itemQtyPrice ? Utils.toRoundStr(item.itemQtyPrice, 2) : Utils.toRoundStr(item.itemPrice * item.itemQty, 2)}</b>

                        </div>
                    </div>

                    {
                        !Utils.isEmpty(item.itemOrderInst) ? (
                            <div className={"col-xs-12 items-price-container"}>
                                <div className={""}>
                                    {self.getItemInstructions(item.itemOrderInst)}
                                </div>
                            </div>
                        ) : null
                    }

                </div>

            );
        });
    }
    getDeliveryAddress(order){

        if (!Utils.isEmptyObj(order)){
            let userName = order.userInfo.name;
            let userInfo = order.userInfo;
            let address       = "";

            if (order === null) {
                return "";
            }
            address = `${userName}, ${userInfo.deliveryAddLine1}
            ${userInfo.deliveryAddLine2}, ${userInfo.deliveryCity}, ${userInfo.deliveryState} ${userInfo.deliveryZip}
            ${Utils.formatPhoneNumber(userInfo.phone)}`;


            return address;
        }
        else {
            return "Order not found!";
        }

    }

    stripeChargeId(order) {

        let stripUserId = this.props.stripeUserId;
        let chargeId = order.paymentDetail.chargeId;
        var stripUrl = "https://dashboard.stripe.com/" + stripUserId + "/payments/" + chargeId;

        let comp = null;
        let txnId = order.paymentDetail.txnId;

        if (order.paymentDetail.paymentType == "Gift Card") {
            comp = (
                <div>
                    {/*customer payment Info*/}

                    <div>
                        <span className="item-in-cart">Payment Source: </span>
                        <span className="ft-16"> Gift Card </span> <br/>
                    </div>


                    <div>

                        {!Utils.isEmpty(order.paymentDetail.giftCardCode) ? (
                            <div>
                                <span className="item-in-cart">Code Used: </span>
                                <span className="ft-16"> {order.paymentDetail.giftCardCode} </span>
                                <br/>
                            </div>

                        ) : null}

                        {!Utils.isEmpty(order.paymentDetail.txnId) ? (
                            <div>
                                <span className="item-in-cart">Transaction Id: </span>
                                <span className="ft-16"> {order.paymentDetail.txnId} </span> <br/>
                            </div>
                        ) : null}

                    </div>
                </div>

            )
        } else {
            comp = (
                <div>
                    {/*customer payment Info*/}
                    <div>
                        <span className="item-in-cart">Payment Card: </span>
                        <span className="ft-16"> {order.paymentType} </span> <br/>
                    </div>

                    <div>
                        <span className="item-in-cart">Payment Charge Id: </span>
                        <span className="ft-16"> <a href={stripUrl}
                                                    target="_blank"> {order.paymentDetail.chargeId}</a></span>
                        <br/>
                    </div>
                </div>
            )
        }

        return comp;
    }

    render() {
        const order = this.state.order;
        // let chargeTag = this.state.chargeData.tag;
        return (
            <div className="section order-success-pg">
                <div className="container" style={{maxWidth: '100%'}}>

                    <div className="row">
                        <div className="col-xs-12 col-md-12 modal-order-container">

                            <div className="row">
                                <div className="container mb-10" style={{maxWidth: '100%'}}>
                                    <div className="box-sizing">
                                        <div className='mt-10 mb-10'>
                                            <div className={"col-xs-12"}>
                                                <div className={""}>
                                                    <h4 className="text-red item-in-cart"><b>Customer
                                                        Info:</b></h4>
                                                    <div>
                                                        <span className="item-in-cart">Name:</span>
                                                        <span
                                                            className="ft-16"> {order.userInfo.name}</span>
                                                        <br/>
                                                    </div>

                                                    <div>
                                                        <span
                                                            className="item-in-cart">Phone No: </span>
                                                        <span
                                                            className="ft-16">{Utils.formatPhoneNumber(order.userInfo.phone)}</span>
                                                        <br/>
                                                    </div>

                                                    {
                                                        Utils.isCurbsidePickup(order) ? (
                                                            <div>
                                                                <span className="item-in-cart">Order Type: </span>
                                                                <span
                                                                    className="ft-16">{CURBSIDEPICKUP}</span>
                                                                <br/>
                                                            </div>

                                                        ) : <div>
                                                            <span className="item-in-cart">Order Type: </span>
                                                            <span
                                                                className="ft-16">{order.orderType}</span>
                                                            <br/>
                                                        </div>

                                                    }

                                                    {
                                                        order.orderInstructions ? (
                                                            <div>
                                                                <span className="item-in-cart">Order Instructions: </span>
                                                                <span
                                                                    className="ft-16"> {order.orderInstructions}</span>
                                                                <br/>
                                                            </div>
                                                        ) : null

                                                    }

                                                    {
                                                        !Utils.isEmptyObj(order.deliveryStatus) ? (


                                                            <div>
                                                                <span className="item-in-cart">Delivery Provider:  </span>
                                                                <span
                                                                    className="ft-16"> {order.deliveryStatus.provider}</span>
                                                                <br/>
                                                                <span className="item-in-cart">Delivery Id:  </span>
                                                                <span className="ft-16"><a
                                                                    href={order.deliveryStatus.trackingURL}
                                                                    target="_blank"> {order.deliveryStatus.id}</a></span>
                                                                <br/>
                                                            </div>
                                                        ) : null
                                                    }

                                                    {
                                                        Utils.isDeliveryOrder(order) ? (
                                                            <div>
                                                                <span className="item-in-cart">Delivery Details: </span>
                                                                <span
                                                                    className="ft-16"> {this.getDeliveryAddress(order)} </span>
                                                                <br/>
                                                            </div>
                                                        ) : null

                                                    }

                                                    {
                                                        Utils.isCurbsidePickup(order) ? (

                                                            <div>
                                                                <span className="item-in-cart">Vehicle Details: </span>
                                                                <span
                                                                    className="ft-16"> {order.curbsidePickup.vColor}, {order.curbsidePickup.vMakeModel} </span>
                                                                <br/>
                                                            </div>

                                                        ) : null

                                                    }

                                                    {
                                                        !Utils.isEmptyObj(order.dineIn) ? (

                                                            <div>
                                                                <span
                                                                    className="item-in-cart">{order.dineIn.serviceLocation}: </span>
                                                                <span
                                                                    className="ft-16"> {order.curbsidePickup.vColor},{order.dineIn.slData} </span>
                                                                <br/>
                                                            </div>

                                                        ) : null

                                                    }

                                                    {/*stripe charge Id*/}
                                                    {this.stripeChargeId(order)}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className="cart_border box-sizing">
                                        <div className={"col-xs-12 mt-10"}>
                                            <h4 className="order-type-details text-red"><b>Items Ordered: </b></h4>
                                            <div className="row">
                                                <div className="container no-gutter" style={{maxWidth: '100%'}}>
                                                    {this.renderOrderRow()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className="cart_border">
                                        <div className="col-xs-offset-5 col-xs-7 order-price-container">
                                            <div className="cart_right cart-price-container">
                                                {this.getCouponStructure(order)}
                                                {this.getDeliveryFeeStructure(order)}
                                                <p>Tax <b
                                                    className="pull-right"> ${Utils.toRoundStr(order.taxes, 2)}</b>
                                                </p>
                                                {this.getDriverTipStructure(order)}
                                                {this.getCustomChargeStructure(order)}
                                                {this.getServiceFeeStructure(order)}
                                            </div>
                                            <div className="cart_total">
                                                <h4>Total<span
                                                    className="pull-right"> ${Utils.toRoundStr(order.totalAmount, 2)}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {
                                this.getPlatformFee(order)
                            }


                            {
                                this.getCustomChargeStructureOfOptional(order)
                            }

                            {
                                this.renderCustomChargeRow(order)
                            }

                            <div className="row mb-15">
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className={"cart_border mt-0"}>
                                        {/*<h4 className="text-red pt-1 mb-0 text-uppercase text-center"><b>***Freshbytes***</b></h4>*/}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/order/order-detail.jsx